import { ThemeInterface } from '../contracts';

export const THEMES: ThemeInterface[] = [
  { name: 'light', baseTheme: 'generic.light' },
  { name: 'dark', baseTheme: 'generic.darkviolet' },
];
